// @generated by protoc-gen-connect-es v1.1.2 with parameter "target=js+dts,import_extension=none"
// @generated from file checkout/mpp/v1/checkout_mpp_api.proto (package checkout.mpp.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddApplePayDomainsRequest, AddApplePayDomainsResponse, AuthorizeRequest, AuthorizeResponse, CreateAndPromoteMerchantSettingsRequest, CreateAndPromoteMerchantSettingsResponse, CreateOrUpdatePaymentLinkRequest, CreateOrUpdatePaymentLinkResponse, CreateSegmentRequest, CreateSegmentResponse, DeleteApplePayDomainsRequest, DeleteApplePayDomainsResponse, DeleteSegmentRequest, DeleteSegmentResponse, ExchangeCodeForTokenRequest, ExchangeCodeForTokenResponse, ExportPaymentLinksRequest, ExportPaymentLinksResponse, GetPaymentLinkRequest, GetPaymentLinkResponse, GetSettingsBundleRequest, GetSettingsBundleResponse, ListPaymentLinksRequest, ListPaymentLinksResponse, RegisterMerchantToApplePayRequest, RegisterMerchantToApplePayResponse, SendPaymentLinkEmailRequest, SendPaymentLinkEmailResponse, UnregisterMerchantToApplePayRequest, UnregisterMerchantToApplePayResponse, UpdateMerchantSettingsRequest, UpdateMerchantSettingsResponse, UploadLogoRequest, UploadLogoResponse, VerifyApplePayDomainsRequest, VerifyApplePayDomainsResponse } from "./checkout_mpp_api_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service checkout.mpp.v1.CheckoutMppV1Service
 */
export const CheckoutMppV1Service = {
  typeName: "checkout.mpp.v1.CheckoutMppV1Service",
  methods: {
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.CreateOrUpdatePaymentLink
     */
    createOrUpdatePaymentLink: {
      name: "CreateOrUpdatePaymentLink",
      I: CreateOrUpdatePaymentLinkRequest,
      O: CreateOrUpdatePaymentLinkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.ListPaymentLinks
     */
    listPaymentLinks: {
      name: "ListPaymentLinks",
      I: ListPaymentLinksRequest,
      O: ListPaymentLinksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Endpoint to directly publish a new merchant settings and make it ACTIVE. Used in MPP Checkout Settings.
     *
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.CreateAndPromoteMerchantSettings
     */
    createAndPromoteMerchantSettings: {
      name: "CreateAndPromoteMerchantSettings",
      I: CreateAndPromoteMerchantSettingsRequest,
      O: CreateAndPromoteMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Endpoint to create a new merchant segment. Used in MPP Checkout Settings.
     *
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.CreateSegment
     */
    createSegment: {
      name: "CreateSegment",
      I: CreateSegmentRequest,
      O: CreateSegmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Endpoint to patch current active settings with an update. To be used in MPP Checkout Settings.
     *
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.UpdateMerchantSettings
     */
    updateMerchantSettings: {
      name: "UpdateMerchantSettings",
      I: UpdateMerchantSettingsRequest,
      O: UpdateMerchantSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.GetSettingsBundle
     */
    getSettingsBundle: {
      name: "GetSettingsBundle",
      I: GetSettingsBundleRequest,
      O: GetSettingsBundleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.DeleteSegment
     */
    deleteSegment: {
      name: "DeleteSegment",
      I: DeleteSegmentRequest,
      O: DeleteSegmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Public API to exchange the authorization code for an access token as part of MPP authorization flow
     *
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.ExchangeCodeForToken
     */
    exchangeCodeForToken: {
      name: "ExchangeCodeForToken",
      I: ExchangeCodeForTokenRequest,
      O: ExchangeCodeForTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.GetPaymentLink
     */
    getPaymentLink: {
      name: "GetPaymentLink",
      I: GetPaymentLinkRequest,
      O: GetPaymentLinkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.ExportPaymentLinks
     */
    exportPaymentLinks: {
      name: "ExportPaymentLinks",
      I: ExportPaymentLinksRequest,
      O: ExportPaymentLinksResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.SendPaymentLinkEmail
     */
    sendPaymentLinkEmail: {
      name: "SendPaymentLinkEmail",
      I: SendPaymentLinkEmailRequest,
      O: SendPaymentLinkEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.UploadLogo
     */
    uploadLogo: {
      name: "UploadLogo",
      I: UploadLogoRequest,
      O: UploadLogoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Public API to register/unregister merchant domains to Apple Pay
     *
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.RegisterMerchantToApplePay
     * @deprecated
     */
    registerMerchantToApplePay: {
      name: "RegisterMerchantToApplePay",
      I: RegisterMerchantToApplePayRequest,
      O: RegisterMerchantToApplePayResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.UnregisterMerchantToApplePay
     * @deprecated
     */
    unregisterMerchantToApplePay: {
      name: "UnregisterMerchantToApplePay",
      I: UnregisterMerchantToApplePayRequest,
      O: UnregisterMerchantToApplePayResponse,
      kind: MethodKind.Unary,
    },
    /**
     * New Apple Pay endpoints
     *
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.AddApplePayDomains
     */
    addApplePayDomains: {
      name: "AddApplePayDomains",
      I: AddApplePayDomainsRequest,
      O: AddApplePayDomainsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.VerifyApplePayDomains
     */
    verifyApplePayDomains: {
      name: "VerifyApplePayDomains",
      I: VerifyApplePayDomainsRequest,
      O: VerifyApplePayDomainsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.DeleteApplePayDomains
     */
    deleteApplePayDomains: {
      name: "DeleteApplePayDomains",
      I: DeleteApplePayDomainsRequest,
      O: DeleteApplePayDomainsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc checkout.mpp.v1.CheckoutMppV1Service.Authorize
     */
    authorize: {
      name: "Authorize",
      I: AuthorizeRequest,
      O: AuthorizeResponse,
      kind: MethodKind.Unary,
    },
  }
};

